import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import { HttpClient } from "../../../api/httpClient";
import { DEFAULT_ENTITY_STATE } from "../../utils";

const baseName = "categories";

const initialState = {
  personal: DEFAULT_ENTITY_STATE,
  approver: DEFAULT_ENTITY_STATE,
  financial: DEFAULT_ENTITY_STATE,
  admin: DEFAULT_ENTITY_STATE,
  director: DEFAULT_ENTITY_STATE,
  insights: DEFAULT_ENTITY_STATE,
};

export const getCategories = createAsyncThunk(
  `${baseName}/getCategories`,
  async (role) => {
    const res = await HttpClient.get({
      url: "/categories",
      params: {
        role,
      },
    });
    return res?.data;
  }
);

export const categoriesSlice = createSlice({
  name: baseName,
  initialState,
  reducers: {
    setupCategories(state, { payload }) {
      const { data, role } = payload || {};
      if (!state[role]) return;
      //CONFIGURAR ENTRADA DE DADOS
      state[role].data =
        data?.map((item) => ({ ...item, id: item?._id })) || [];
    },

    resetCategoriesStatus(state, { payload }) {
      const { role } = payload;
      state[role].status = "idle";
    },

    //ADM ACTIONS
    addCategory(state, { payload }) {
      state.admin.data.push(payload);
    },
    updateCategory(state, { payload }) {
      const { id, changes } = payload;
      const index = state.admin.data.findIndex((item) => item.id === id);
      if (index !== -1) {
        state.admin.data[index] = {
          ...state.admin.data[index],
          ...changes,
        };
      }
    },
    removeCategory(state, { payload }) {
      state.admin.data = [
        ...state.admin.data?.filter((item) => item?.id !== payload),
      ];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCategories.pending, (state, action) => {
        const role = action.meta.arg || "personal";
        state[role].status = "loading";
        state[role].error = null;
      })
      .addCase(getCategories.rejected, (state, action) => {
        const role = action.meta.arg || "personal";
        state[role].status = "failed";
        state[role].error = action.error.message || null;
      })
      .addCase(getCategories.fulfilled, (state, action) => {
        const role = action.meta.arg || "personal";
        state[role].status = "succeeded";
        state[role].error = null;

        //Dados API
        const data = action.payload || [];
        categoriesSlice.caseReducers.setupCategories(state, {
          payload: {
            data,
            role,
          },
        });
      });
  },
});

export const {
  addCategory,
  removeCategory,
  setupCategories,
  updateCategory,
  resetCategoriesStatus,
} = categoriesSlice.actions;

export default categoriesSlice.reducer;

export const selectCategoriesByRole = createSelector(
  [(state) => state.categories, (state, role) => role],
  (categoriesState = {}, role = "") => {
    const prevData = categoriesState[role] || DEFAULT_ENTITY_STATE;

    return {
      ...prevData,
      total: prevData?.data?.length || 0,
    };
  }
);

export const selectCategoryById = createSelector(
  [selectCategoriesByRole, (state, role, categoryId) => categoryId],
  (categoriesState = {}, categoryId = "") => {
    return categoriesState?.data?.find((item) => item?.id === categoryId) || {};
  }
);
